import { msg } from '@lingui/macro';
import { useLingui } from "@lingui/react";
import AddIcon from '@mui/icons-material/Add';
import CircleIcon from '@mui/icons-material/Circle';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Chip, CircularProgress,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import * as lod from 'lodash';
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import httpReq from "../../../services/httpReq";
import HomeMadeDialog from "../../dialogs/HomeMadeDialog";
import { ActionsToolBar } from "../../grid/ActionsToolbar";
import ModalAddValue from "./values/ModalAddValue";
import ModalManageValue from "./values/ModalManageValue";
import FullPageLoader from '../../loaders/FullPageLoader';
import { SketchPicker } from 'react-color';
import SaveIcon from '@mui/icons-material/Save'
import CloseIcon from '@mui/icons-material/Close'

const ModalEditTag = ({ rowToEdit, isModalEditOpen, setIsModalEditOpen, isMobile }) => {
  const { control, formState, handleSubmit, getValues } = useForm({ mode: 'onChange', defaultValues: { name: rowToEdit.name } })
  const { _ } = useLingui()
  const [isOpenModalManageValue, setIsOpenModalManageValue] = useState(false)
  const [isOpenModalAddValue, setIsOpenModalAddValue] = useState(false)
  const [valueToEdit, setValueToEdit] = useState(null)
  const [tagToEdit, setTagToEdit] = useState()
  const [isOpenDialog, setIsOpenDialog] = useState(false)
  const [isMultiple, setIsMultiple] = useState(rowToEdit.isMultiple)
  const [isDeletable, setIsDeletable] = useState(rowToEdit.isDeletable)
  const [isLoading, setIsLoading] = useState(false)
  const [tagColor,setTagColor] = useState(rowToEdit.color)

  const updateTag = async () => {
    const values = getValues()
    const vv = Object.assign(tagToEdit, values)
    vv.isMultiple = isMultiple
    vv.isDeletable = isDeletable
    vv.color = tagColor
    const res = await httpReq('Tag/Update', 'PATCH', vv, true)
    if (!res || res.responseAnyError) return;
    if(!res.responseAnyError){
    setIsModalEditOpen(false)
    }
  }

  useEffect(() => {
    if (!isOpenModalManageValue) {
      getValuesTag()
      setValueToEdit(null)
    }
  }, [isOpenModalManageValue])

  useEffect(() => {
    if (!isOpenModalAddValue) {
      getValuesTag()
    }
  }, [isOpenModalAddValue])

  const getValuesTag = async () => {
    setIsLoading(true)
    const values = await httpReq(`/TagValue/GetList/${rowToEdit.id}`, 'GET', null, true)
    if (!values || values.responseAnyError) return;
    const v = { ...rowToEdit }
    v.values = [...lod.orderBy(values.responseData, ['id'], 'asc')].map((value) => {
      value.isLoading = false;
      value.isLoaded = false;
      return value;
    });
    setTagToEdit(v)
    setIsLoading(false)
  }

  const updateLoading = (tagValueIndex, isLoading) => {
    const tagValues = [...tagToEdit.values]
    tagValues[tagValueIndex].isLoading = isLoading;
    setTagToEdit({...tagToEdit,values: tagValues})
  }

  const updateLoaded = (tagValueIndex, isLoading) => {
    const tagValues = [...tagToEdit.values]
    tagValues[tagValueIndex].isLoaded = isLoading;
    setTagToEdit({...tagToEdit,values: tagValues})
  }

  const updateImage = (tagValueIndex, fileSrc) => {
    const tagValues = [...tagToEdit.values]
    tagValues[tagValueIndex].fileSrc = fileSrc;
    setTagToEdit({...tagToEdit,values: tagValues})
  }

  useEffect(() => {
    if(!tagToEdit) return;
    const values = tagToEdit.values
    values.forEach((value, tagValueIndex) => {
      if (value.isLoaded === false && value.isLoading === false && value.fileContent === '') {
        updateLoading(tagValueIndex, true);
        httpReq('TagValue/Get/' + value.id, 'GET', null, true).then((res) => {
          if (!res || res.responseAnyError) return;
          if (res.responseAnyError) return;
          const tagValue = res.responseData;
          if (tagValue.fileContent) {
            const fileSrc = "data:" + tagValue.fileMimeType + ";base64," + tagValue.fileContent;

            updateImage( tagValueIndex, fileSrc);
          }

          updateLoading(tagValueIndex, false);
          updateLoaded(tagValueIndex, true);
        })
      }
    })


  }, [tagToEdit])


  const getHexFromRGB = (color) => {
     setTagColor(color.hex)
}

  const deleteValue = async () => {
    const res = await httpReq(`TagValue/Delete/${valueToEdit.id}`, 'DELETE', null, true)
    if (!res || res.responseAnyError) return;
    const v = { ...tagToEdit }
    const idx = [...v.values].findIndex(v => v.id === res.responseData.id)
    const newValues = [...v.values]
    newValues.splice(idx, 1)
    v.values = newValues
    setTagToEdit(v)
    setValueToEdit(null)
    setIsOpenDialog(false)
  }

  const ToolBarEdit = (props) => {
    let selectedRow = props.data;


    const editAction = () => {
      setIsOpenModalManageValue(true)
      setValueToEdit(selectedRow)


    };

    const deleteAction = () => {
      setValueToEdit(selectedRow)
      setIsOpenDialog(true)


    };

    return <ActionsToolBar hasEdit editAction={editAction} hasDelete deleteAction={deleteAction} />;
  };
  const RenderChip = (props) => {
    const value = props.data
    // const values = props.data.values;
    return (
        value.isLoading ?
            <Chip
                key={'tag-value-loading-' + value.id}
                icon={<CircularProgress color="primary" size={25}/>}
                label={value.value}
                sx={{
                  width: '30%',
                  cursor: 'pointer',
                  margin: '0 5px',
                  fontWeight: 'bold',
                  backgroundColor: value.color
                }}
                variant="outlined"
            /> :
            value.isLoaded && (value.fileSrc && value.fileSrc !== '') ?
                <Chip
                    key={'tag-value-' + value.id}
                    sx={{
                      width: '30%',
                      cursor: 'pointer',
                      margin: '0 10px',
                      color: 'white',
                      backgroundColor: value.color
                    }}
                    icon={<img src={value.fileSrc} style={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%'
                    }} alt={'tag-value-image'}/>}
                    label={value.value}
                    variant="outlined"
                />
                :
                <Chip
                    sx={{
                      width: '30%',
                      cursor: 'pointer',
                      margin: '0 10px',
                      color: 'white',
                      backgroundColor: value.color
                    }}
                    key={'tag-value-' + value.id}
                    label={value.value}
                    variant="outlined"
                />
    )
  }
  const colsEditLabel = [
    {
      cellRenderer: RenderChip,
      headerName: 'Value',

      flex: 3
    },
    { headerName: 'Actions', cellRenderer: ToolBarEdit, flex: !isMobile ? 1 : 2 }
  ]
  return (
    <>
      <Modal sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} open={isModalEditOpen}>
        <Card sx={{ width: !isMobile ? '60vw' : '100vw', height: !isMobile ? '80vh' : '100vh' }}>
        <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              px: 2,
              py: 1.5,
            }}
          >

            <Typography variant="h6" sx={{ flex: 1 }}>
              {`Edit ${rowToEdit.name}`}
            </Typography>

            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              <Button sx={{ borderRadius: 10 }} variant="contained" disabled={!formState.isValid} onClick={() => updateTag()}>
                <SaveIcon color={!formState.isValid ? 'inherit' : 'white'} />
              </Button>
              <IconButton onClick={() => {
                setIsModalEditOpen(false)
              }
              }><CloseIcon color="error" /></IconButton>
            </Box>
          </Box>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} >
                <Controller
                  name='name'
                  control={control}
                  defaultValue=""
                  render={({ field, fieldState }) => (
                    <TextField
                      margin={isMobile ? 'dense' : 'normal'}
                      fullWidth={true}
                      required
                      label={_(msg`Tag Name`)}
                      autoComplete='name'
                      autoFocus
                      error={!!fieldState.error}
                      helperText={fieldState.error ? fieldState.error.message : null}
                      {...field}
                    />
                  )}
                  rules={{ required: _(msg`Tag Name is required`) }}
                />
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 2 }}>
                <Box sx={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                  <Checkbox checked={isMultiple} onChange={e => {
                    setIsMultiple(e.target.checked)
                  }} />
                  <Typography>Is multiple?</Typography>
                </Box>
                <Box sx={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                  <Checkbox checked={isDeletable} onChange={e => {
                    setIsDeletable(e.target.checked)
                  }} />
                  <Typography>Is deletable?</Typography>
                </Box>

              </Grid>

              <Grid display={'flex'} justifyContent={'flex-end'} sx={{ width: '100%' }} item xs={12} >
                <IconButton onClick={() => setIsOpenModalManageValue(true)} variant='outlined' sx={{ borderRadius: '4px !important', float: 'right' }}> <AddIcon /></IconButton>
              </Grid>
              {/**
              <Grid item xs={3} sx={{display:'flex',justifyContent:'center'}}>
                <SketchPicker
                    name={`color-picker-${rowToEdit.name}`}
                    key={`color-picker-${rowToEdit.name}`}
                    styles={{
                      default: {
                        picker: {
                          width: '150px', // riduce la larghezza
                          height: '150px'
                        },
                      },
                    }}
                    color={tagColor}
                    onChange={(color) => {
                      getHexFromRGB(color);
                    }}
                />
              </Grid>
               */}
              <Grid item xs={12}>
                {tagToEdit &&
                  <div style={{ height: 300 }}>
                    <AgGridReact rowData={tagToEdit.values} columnDefs={colsEditLabel} />
                  </div>
                }
              </Grid>

            </Grid>
          </CardContent>
        </Card>
      </Modal>
      {isOpenDialog &&
        <HomeMadeDialog
          isOpen={isOpenDialog}
          labelClose={'Close'}
          labelConfirm={'Confirm'}
          text={_(msg`Are you sure?`)}
          fnClose={() => setIsOpenDialog(false)}
          fnConfirmAction={() => deleteValue()}
          title={`Delete record`} />}
      {isOpenModalManageValue && <ModalManageValue tagToEdit={tagToEdit} isOpenModalManageValue={isOpenModalManageValue} setIsOpenModalManageValue={setIsOpenModalManageValue} setValueToEdit={setValueToEdit} isMobile={isMobile} valueToEdit={valueToEdit} />}
    </>
  )
}
export default ModalEditTag